export default __webpack_public_path__ + "d6b6175ac8fd45cc39380b2be0093772.svg";